export default __webpack_public_path__ + "static/media/menTie.708b8304.svg";